import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { MdTableCell } from '../common/MdRowActions';

const options = [
  { value: '0', label: 'Ausente' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
];

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatTipoActa(tipoActa) {
  if (tipoActa === 'R') return 'Regular';
  if (tipoActa === 'L') return 'Libre';
  if (tipoActa === 'E') return 'Equivalencia';
  return '';
}

export class CargarActaExamen extends Component {
  static displayName = CargarActaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      loadError: '',
      errorMessage: '',
      searchData: [],
      alumnos: [],
      materia: '',
      fechaExamen: new Date().toString(),
      tipoActa: '',
      id: this.props.match.params.id,
      resultados: [],
      folio: '',
      libro: '',
      encabezadoOk: false,
      success: false,
      valueOral: [],
      valueEscrito: [],
      valueNota: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWActasExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loading: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleOnChangeFolio = (e) => {
    this.clearFeedback();
    this.setState({ folio: e.target.value });
  };

  handleOnChangeLibro = (e) => {
    this.clearFeedback();
    this.setState({ libro: e.target.value });
  };

  handleNotaOral = (e, id) => {
    const index = this.state.resultados.findIndex((x) => x.id === e);
    if (index >= 0) {
      const element = this.state.resultados[index];
      element.oral = id.value;
      this.state.resultados.splice(index, 1, element);
      this.setState({ valueOral: id });
    }
  };

  handleNotaEscrito = (e, id) => {
    const index = this.state.resultados.findIndex((x) => x.id === e);
    if (index >= 0) {
      const element = this.state.resultados[index];
      element.escrito = id.value;
      this.state.resultados.splice(index, 1, element);
      this.setState({ valueEscrito: id });
    }
  };

  handleNotaPromedio = (e, id) => {
    const index = this.state.resultados.findIndex((x) => x.id === e);
    if (index >= 0) {
      const element = this.state.resultados[index];
      element.nota = id.value;
      this.state.resultados.splice(index, 1, element);
      this.setState({ valueNota: id });
    }
  };

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.saving)) return;

    if (this.state.folio === 0 || this.state.libro.trim() === '0') {
      this.setState({ errorMessage: 'Ingrese Libro y/o Folio' });
      return;
    }

    this.postNotas();
  }

  getSelectValue(alumnoId, field) {
    const row = this.state.resultados.find((y) => y.id === alumnoId);
    if (!row) {
      return null;
    }
    return options.filter((x) => x.value == row[field]);
  }

  renderTable(alumnos) {
    if (!alumnos.length) {
      return <p className="md-form-page__empty-hint">No hay alumnos para cargar en esta acta.</p>;
    }

    const isBusy = this.state.loading || this.state.saving;

    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="cargar-acta-examen-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Nota Examen Oral</th>
              <th scope="col">Nota Examen Escrito</th>
              <th scope="col">Nota Examen Promedio</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.detalleActaCod}>
                <MdTableCell>{alumno.alumnoDni}</MdTableCell>
                <MdTableCell>{alumno.alumnoNombre}</MdTableCell>
                <td>
                  <div className="md-form-page__select-wrap">
                    <Select
                      classNamePrefix="md-form-page__select"
                      classNames={SELECT_CLASS_NAMES}
                      options={options}
                      disabled
                      placeholder="Seleccione un resultado"
                      value={this.getSelectValue(alumno.detalleActaCod, 'oral')}
                      onChange={(option) => this.handleNotaOral(alumno.detalleActaCod, option)}
                      isDisabled={isBusy}
                    />
                  </div>
                </td>
                <td>
                  <div className="md-form-page__select-wrap">
                    <Select
                      classNamePrefix="md-form-page__select"
                      classNames={SELECT_CLASS_NAMES}
                      options={options}
                      disabled
                      value={this.getSelectValue(alumno.detalleActaCod, 'escrito')}
                      onChange={(option) => this.handleNotaEscrito(alumno.detalleActaCod, option)}
                      isDisabled={isBusy}
                    />
                  </div>
                </td>
                <td>
                  <div className="md-form-page__select-wrap">
                    <Select
                      classNamePrefix="md-form-page__select"
                      classNames={SELECT_CLASS_NAMES}
                      options={options}
                      disabled
                      value={this.getSelectValue(alumno.detalleActaCod, 'nota')}
                      onChange={(option) => this.handleNotaPromedio(alumno.detalleActaCod, option)}
                      isDisabled={isBusy}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    if (this.state.success || this.state.encabezadoOk) {
      return <Redirect to="/md-aex" />;
    }

    const { loading, saving, loadError, errorMessage, searchData, materia, tipoActa, fechaExamen, libro, folio } = this.state;
    const isBusy = loading || saving;

    const contents = loading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(searchData);

    return (
      <div className="md-page md-form-page md-cargar-acta-examen">
        <Link className="md-form-page__back" to="/md-aex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 id="cargar-acta-examen-title" className="md-form-page__title">
          Cargar Resultados de Acta de Examen
        </h1>

        {materia ? (
          <p className="md-form-page__subtitle">
            Materia: {materia}
            {' · '}
            Tipo acta: {formatTipoActa(tipoActa)}
            {' · '}
            Fecha examen: {constantClass.formatDisplayDate(fechaExamen)}
          </p>
        ) : null}

        <div className="md-form-page__feedback" aria-live="polite" role="status">
          {loadError ? (
            <div className="md-form-page__error" role="alert">{loadError}</div>
          ) : null}
        </div>

        <form className="md-form-page__form" onSubmit={this.handleSubmit}>
          {!loading ? (
            <div className="md-form-page__card">
              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aex-load-libro">
                  Libro
                </label>
                <input
                  id="aex-load-libro"
                  className="md-form-page__input"
                  type="text"
                  value={libro}
                  onChange={this.handleOnChangeLibro}
                  disabled={isBusy}
                />
              </div>
              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aex-load-folio">
                  Folio
                </label>
                <input
                  id="aex-load-folio"
                  className="md-form-page__input"
                  type="text"
                  value={folio}
                  onChange={this.handleOnChangeFolio}
                  disabled={isBusy}
                />
              </div>
            </div>
          ) : null}

          {contents}

          {!loading && searchData.length > 0 ? (
            <>
              <div className="md-form-page__feedback md-form-page__feedback--before-actions" aria-live="polite" role="status">
                {errorMessage ? (
                  <div className="md-form-page__error" role="alert">{errorMessage}</div>
                ) : null}
                {saving ? (
                  <div className="md-form-page__loading">Guardando resultados...</div>
                ) : null}
              </div>
              <div className="md-form-page__actions">
                <button
                  type="submit"
                  className="md-form-page__btn md-form-page__btn--primary"
                  disabled={isBusy}
                >
                  {saving ? 'Guardando...' : 'Guardar resultados'}
                </button>
              </div>
            </>
          ) : null}
        </form>
      </div>
    );
  }

  async populateData() {
    this.setState({ loading: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/aex/detalle/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudo cargar el detalle del acta.'
        ),
      });
      return;
    }

    const resultados = [];
    data.returnModel.forEach((x) => {
      resultados.push({ id: x.detalleActaCod, oral: 0, escrito: 0, nota: 0 });
    });
    const defaultValueAnioDictado = options.filter((x) => x.value === '0');

    this.setState({
      alumnos: data.returnModel,
      folio: data.returnModel[0].actaExamenFolio ? data.returnModel[0].actaExamenFolio : '',
      libro: data.returnModel[0].actaExamenLibro ? data.returnModel[0].actaExamenLibro : '',
      materia: data.returnModel[0].materiaCarreraNombre.trim() + ' - ' + data.returnModel[0].carreraNombre.trim(),
      fechaExamen: data.returnModel[0].mesaExamenFechaExamen,
      tipoActa: data.returnModel[0].actaExamenTipo,
      searchData: data.returnModel,
      loading: false,
      resultados,
      valueOral: defaultValueAnioDictado,
      valueEscrito: defaultValueAnioDictado,
      valueNota: defaultValueAnioDictado,
    });
  }

  async postNotas() {
    if (isSubmitInProgress(this.state.saving)) return;

    this.setState({ saving: true, errorMessage: '' });

    const objects = [];
    this.state.resultados.map((tag) => {
      objects.push({
        DetalleActaCod: tag.id,
        DetalleActaNota: tag.nota,
        DetalleActaOral: tag.oral,
        DetalleActaEscrito: tag.escrito,
      });
      return null;
    });

    const { data } = await constantClass.apiFetch('api/aex', {
      method: 'POST',
      body: JSON.stringify({
        ActaExamenFolio: this.state.folio,
        ActaExamenLibro: this.state.libro,
        ActaExamenNacta: this.state.id,
        Resultados: objects,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        saving: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron guardar los resultados. Intente nuevamente.'
        ),
      });
      return;
    }

    window.alert('Acta cargada exitosamente');
    this.setState({ saving: false, success: true });
  }
}
